import { env } from "../../../env";
import api from "../../../api";

var baseurl = env.REACT_APP_API_URL_SLGL;

class UserActionHistoryClient {
    async GetUserActionHistoryLawAct(lawActId, isBackground) {
        try {
            var response = await api.get(baseurl + `/UserActionHistory/GetUserActionHistoryLawAct/${lawActId}`, { isBackground: isBackground });
            return response.data;
        }
        catch (err) {
            if (err.response.status === 400) return err.response.data;
            else return err.response;
        }
    }
    async GetUserActionHistoryNumber(numberId, isBackground) {
        try {
            var response = await api.get(baseurl + `/UserActionHistory/GetUserActionHistoryNumber/${numberId}`, { isBackground: isBackground });
            return response.data;
        }
        catch (err) {
            if (err.response.status === 400) return err.response.data;
            else return err.response;
        }
    }
}

export default UserActionHistoryClient;